import permissions from '../permissions'

const ASSET_INVENTORY_LIST = [
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.VISUALIZE,
    tag: permissions.ASSET_INVENTORY.SHOW,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.MANAGE,
    tag: permissions.ASSET_INVENTORY.MANAGE,
  },
]

export default ASSET_INVENTORY_LIST
